import React, { useState, useEffect, useRef } from 'react';
import { Link, useNavigate } from 'react-router-dom';
// import { getMedicalInfo } from '../services/assuranceService';
import SignatureCanvas from "react-signature-canvas";
import { postSubscribe, getMedicalInfo } from '../services/assuranceService';

export default function MedicalDeclaration() {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const [formData, setFormData] = useState(null);
  const [hasSpouse, setHasSpouse] = useState(false);
  const [numberOfChildren, setNumberOfChildren] = useState(0);
  const [declared, setDeclared] = useState(false);
  const [medicalQuestions, setMedicalQuestions] = useState([]);
  const sigRef = useRef(null);
  const [signature, setSignature] = useState(null);

  const clearSignature = () => {
    sigRef.current.clear();
    setSignature(null);
  };

  useEffect(() => {
    // Récupérer les données du formulaire médical
    const savedFormData = localStorage.getItem('step6FormData');
    const savedHasSpouse = localStorage.getItem('hasSpouse');
    const savedNumberOfChildren = localStorage.getItem('numberOfChildren');

    if (savedFormData) setFormData(JSON.parse(savedFormData));
    if (savedHasSpouse) setHasSpouse(savedHasSpouse === 'true');
    if (savedNumberOfChildren) setNumberOfChildren(parseInt(savedNumberOfChildren));

    // Charger les questions médicales depuis l'API
    const fetchMedicalQuestions = async () => {
      try {
        const result = await getMedicalInfo();
        if (result && result.data) {
          setMedicalQuestions(result.data);
        }
      } catch (err) {
        console.error('Erreur lors du chargement des questions médicales:', err);
      }
    };

    fetchMedicalQuestions();
  }, []);

  // const handleContinue = () => {
  //   if (!declared) {
  //     alert('Veuillez confirmer la déclaration avant de continuer.');
  //     return;
  //   }

    // Signature
    // const data = sigRef.current.getTrimmedCanvas().toDataURL("image/png");
    // if (!data) {
    //   alert('Veuillez signer la déclaration avant de continuer.');
    //   return;
    // }
    // setSignature(data);
    // localStorage.setItem('signature', signature.toString());

    // navigate('/congratulation');
  // };

  // Sauvegarder les données du formulaire et calculer la cotation
  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    setError(null);

    // const formData = new FormData(e.target);
    // const data = {};
    // for (let [key, value] of formData.entries()) {
    //   if (data[key]) {
    //     if (Array.isArray(data[key])) {
    //       data[key].push(value);
    //     } else {
    //       data[key] = [data[key], value];
    //     }
    //   } else {
    //     data[key] = value;
    //   }
    // }

    // localStorage.setItem('step6FormData', JSON.stringify(data));
    // localStorage.setItem('previousInsurance', JSON.stringify(previousInsurance));

    // Récupérer les données des étapes précédentes
    const selectedPackage = localStorage.getItem('selectedPackage');
    const assuredType = localStorage.getItem('assuredType');
    const activityClass = localStorage.getItem('activityClass');
    const isPrincipal = localStorage.getItem('isPrincipal');
    const subscriberData = JSON.parse(localStorage.getItem('subscriberData') || '{}');
    const subscriberPreviews = JSON.parse(localStorage.getItem('subscriberPreviews') || '{}');
    const principalData = JSON.parse(localStorage.getItem('principalData') || '{}');
    const principalPreviews = JSON.parse(localStorage.getItem('principalPreviews') || '{}');
    const spouse = JSON.parse(localStorage.getItem('spouse') || '{}');
    const children = JSON.parse(localStorage.getItem('children') || '[]');
    const periodicity = localStorage.getItem('periodicity');
    const effectiveDate = localStorage.getItem('effectiveDate');
    const medical_questionnaire = JSON.parse(localStorage.getItem('medical_questionnaire') || '{}');

    // Récupérer la date de naissance du principal selon si le souscripteur est le principal ou non
    const principalDob = isPrincipal === 'yes'
      ? subscriberData.date_naissance
      : principalData.date_naissance;

    // Vérifier que les données essentielles sont présentes
    if (!selectedPackage) {
      setError('Erreur: Package non sélectionné');
      setIsLoading(false);
      return;
    }
    if (!assuredType) {
      setError('Erreur: Type d\'assurance non sélectionné');
      setIsLoading(false);
      return;
    }
    if (!activityClass) {
      setError('Erreur: Classe d\'activité non sélectionné');
      setIsLoading(false);
      return;
    }
    if (!principalDob || principalDob.trim() === '') {
      setError('Erreur: Date de naissance du principal manquante ou invalide');
      setIsLoading(false);
      return;
    }

    // Vérifier le format de la date (YYYY-MM-DD)
    const dateRegex = /^\d{4}-\d{2}-\d{2}$/;
    if (!dateRegex.test(principalDob)) {
      setError('Erreur: Format de date invalide. Utilisez le format YYYY-MM-DD');
      setIsLoading(false);
      return;
    }

    // // Extraire les conditions médicales pour l'assuré principal
    // const principalMedicalConditions = extractMedicalConditions(data, 'principal_insured');

    // // Construire l'objet médical au format attendu par l'API
    // const medical = {
    //   principal_insured: principalMedicalConditions
    // };

    // // Ajouter les conditions médicales du conjoint si présent
    // if (hasSpouse) {
    //   const spouseMedicalConditions = extractMedicalConditions(data, 'spouse');
    //   medical.spouse = spouseMedicalConditions;
    // }

    // // Ajouter les conditions médicales des enfants si présents
    // if (numberOfChildren > 0) {
    //   medical.children = {};
    //   for (let i = 1; i <= numberOfChildren; i++) {
    //     const childMedicalConditions = extractMedicalConditions(data, `child_${i}`);
    //     medical.children[i.toString()] = childMedicalConditions;
    //   }
    // }

    // Construire le payload au format attendu par l'API
    // const cotationData = {
    //   package: selectedPackage,
    //   type: assuredType,
    //   activity_class: activityClass,
    //   principal_insured_dob: principalDob,
    //   medical: medical
    // };

    if (!declared) {
      alert('Veuillez confirmer la déclaration avant de continuer.');
      setIsLoading(false);
      return;
    }

    if (!sigRef.current || sigRef.current.isEmpty()) {
      alert("Veuillez signer la déclaration avant de continuer.");
      setIsLoading(false);
      return;
    }

    // Récupérer le canvas complet sans trim
    const canvas = sigRef.current.getCanvas();
    const signatureImg = canvas.toDataURL("image/png");
    setSignature(signatureImg);

    //Enregistrer la souscription et faire la cotation
    const subscribeData = {
      underwriter: subscriberData,
      underwriter_files: subscriberPreviews,
      type: assuredType,
      formula: selectedPackage,
      principal_insured: principalData,
      principal_insured_files: principalPreviews,
      spouse: spouse,
      children: children,
      periodicity: periodicity,
      effect: effectiveDate,
      activity_class: activityClass,
      medical_questionnaire: medical_questionnaire,
      signature: signatureImg
    };

    // Ajouter la date de naissance du conjoint si présent
    // if (hasSpouse && spouse.dob) {
    //   subscribeData.spouse_dob = spouse.dob;
    // }

    // Ajouter les enfants avec leurs dates de naissance
    // if (numberOfChildren > 0 && children.length > 0) {
    //   subscribeData.children = children
    //     .filter(child => child && child.dob)
    //     .map(child => ({ dob: child.dob }));
    // }

    // try {
    //   const result = await postCotation(cotationData);

    //   // Vérifier si la réponse est valide
    //   if (!result || (typeof result !== 'object' && typeof result !== 'number')) {
    //     setError('Erreur: Réponse API invalide');
    //     setIsLoading(false);
    //     return;
    //   }

    //   localStorage.setItem('cotationResult', JSON.stringify(result));

    //   // Naviguer vers la page de déclaration après succès
    //   navigate('/medical-declaration');
    // } catch (err) {
    //   setError('Erreur lors du calcul de la cotisation: ' + (err.response?.data?.message || err.message));
    //   setIsLoading(false);
    // }

    try {
      const result = await postSubscribe(subscribeData);

      // Vérifier si la réponse est valide
      if (!result || (typeof result !== 'object' && typeof result !== 'number')) {
        setError('Erreur: Réponse API invalide');
        setIsLoading(false);
        return;
      }

      localStorage.setItem('subscribeResult', JSON.stringify(result));
      console.log(localStorage.getItem('subscribeResult'))

      // Naviguer vers la page de déclaration après succès
      // navigate('/medical-declaration');
      navigate('/congratulation');
    } catch (err) {
      setError('Erreur lors de la souscription: ' + (err.response?.data?.error || err.message));
      setIsLoading(false);
    }
  };

  // Fonction pour extraire les réponses médicales du formulaire
  const getMedicalResponses = (prefix) => {
    const responses = [];
    if (!formData || medicalQuestions.length === 0) return responses;

    // Créer une map des questions par clé pour un accès rapide
    const questionMap = {};
    medicalQuestions.forEach(q => {
      questionMap[q.key] = q;
    });

    // Récupérer les questions depuis le localStorage ou afficher toutes les clés du formulaire
    Object.keys(formData).forEach(key => {
      if (key.startsWith(`${prefix}[`)) {
        // Extraire le nom de la question et la réponse
        const questionMatch = key.match(/\[(.*?)\]/);
        if (questionMatch) {
          const questionKey = questionMatch[1];
          const value = formData[key];
          
          // Ignorer les champs d'info supplémentaires (traités séparément)
          if (value && !key.includes('_infos')) {
            const question = questionMap[questionKey];
            
            if (question) {
              // Convertir la réponse en français si c'est un booléen
              let displayValue = value;
              if (question.type === 'boolean') {
                if (Array.isArray(value)) {
                  displayValue = value.map(v => v === 'true' ? 'Oui' : v === 'false' ? 'Non' : v).join(', ');
                } else {
                  displayValue = value === 'true' ? 'Oui' : value === 'false' ? 'Non' : value;
                }
              } else if (Array.isArray(value)) {
                displayValue = value.join(', ');
              }
              
              // Si la réponse est "Oui" et qu'il y a des champs additionnels (more_infos)
              if ((displayValue === 'Oui' || value === 'true') && question.more_infos) {
                const infoKey = `${prefix}[${questionKey}_infos]`;
                const infoValue = formData[infoKey];
                if (infoValue) {
                  const fieldLabel = question.more_infos.field?.label || question.more_infos.field?.name || 'Info';
                  displayValue += `\n${fieldLabel}: ${infoValue}`;
                }
              }
              
              responses.push({ 
                question: question.name, 
                answer: displayValue
              });
            }
          }
        }
      }
    });

    return responses;
  };

  const principalResponses = getMedicalResponses('principal_insured');
  const spouseResponses = hasSpouse ? getMedicalResponses('spouse') : [];
  const childrenResponses = numberOfChildren > 0 ? Array.from({ length: numberOfChildren }, (_, i) => ({
    childNumber: i + 1,
    responses: getMedicalResponses(`child_${i + 1}`)
  })) : [];

  return (
    <div className="py-10 lg:py-16 bg-[#e4eef9]">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <h1 className="text-center text-4xl font-bold">Formulaire de souscription</h1>
        
        <div className="mt-8 bg-white p-6 lg:p-10 rounded-xl shadow-sm">
          {/* Section Récapitulatif Questionnaire Médical */}
          <div className="mb-8">
            <h2 className="text-lg font-bold text-secondary mb-6">Récapitulatif du questionnaire médical</h2>

            {/* <div className="bg-primary text-white p-4 rounded-t-lg font-bold">
              Questionnaire Médical
            </div> */}
            <div className="border border-gray-300">
              <div className="overflow-x-auto">
                <table className="w-full border-collapse">
                  <thead>
                    <tr className="bg-gray-100">
                      <th className="border border-gray-300 p-3 text-left font-bold">Questions</th>
                      <th className="border border-gray-300 p-3 text-left font-bold">Assuré Principal</th>
                      {hasSpouse && <th className="border border-gray-300 p-3 text-left font-bold">Conjoint(e)</th>}
                      {[...Array(numberOfChildren)].map((_, i) => (
                        <th key={i} className="border border-gray-300 p-3 text-left font-bold">Enfant {i + 1}</th>
                      ))}
                    </tr>
                  </thead>
                  <tbody>
                    {medicalQuestions.map((question, rowIndex) => (
                      <tr key={question.key} className={rowIndex % 2 === 0 ? 'bg-white' : 'bg-gray-50'}>
                        <td className="border border-gray-300 p-3 font-medium">{question.name}</td>
                        <td className="border border-gray-300 p-3 whitespace-pre-wrap">
                          {principalResponses
                            .filter(r => r.question === question.name)
                            .map(r => r.answer)
                            .join('\n') || 'Aucun'}
                        </td>
                        {hasSpouse && (
                          <td className="border border-gray-300 p-3 whitespace-pre-wrap">
                            {spouseResponses
                              .filter(r => r.question === question.name)
                              .map(r => r.answer)
                              .join('\n') || 'Aucun'}
                          </td>
                        )}
                        {[...Array(numberOfChildren)].map((_, i) => (
                          <td key={i} className="border border-gray-300 p-3 whitespace-pre-wrap">
                            {childrenResponses[i]?.responses
                              .filter(r => r.question === question.name)
                              .map(r => r.answer)
                              .join('\n') || 'Aucun'}
                          </td>
                        ))}
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2">
            {/* Section Déclaration */}
            <div className="mb-8 p-6 bg-blue-50 rounded-lg border-l-4 border-primary">
              <h2 className="text-lg font-bold text-primary mb-4">Déclaration sur l'honneur</h2>
              <div className="text-sm text-gray-700 space-y-3 mb-6 leading-relaxed">
                <p>
                  <strong>Je soussigné(e)</strong> certifie sincères et véritables mes déclarations aux questions du présent bulletin d'adhésion, et accepte de me soumettre sur demande de la Société d'Assurances à une visite médicale de son médecin conseil.
                </p>
                <p>
                  Toute fausse réponse ou omission au présent questionnaire est soumise aux sanctions prévues par les articles 18 et 19 du code CIMA.
                </p>
              </div>
              <label className="flex items-center gap-3 cursor-pointer p-4 bg-white rounded-lg border-2 border-gray-300 hover:border-primary transition">
                <input
                  type="checkbox"
                  checked={declared}
                  onChange={(e) => setDeclared(e.target.checked)}
                  className="h-5 w-5 text-primary cursor-pointer"
                />
                <span className="text-gray-700 font-medium">
                  Je confirme les déclarations ci-dessus et accepte les conditions
                </span>
              </label>
            </div>

            {/* Section Signature */}
            <div className="mb-8 md:ml-4 p-6 bg-gray-50 rounded-lg border-l-4 border-primary">
              <h2 className="text-lg font-bold text-primary mb-4">Signature numérique</h2>

              <p className="text-sm text-gray-600 mb-4">
                Veuillez apposer votre signature ci-dessous pour valider votre déclaration.
              </p>

              <div className="border-2 border-dashed border-gray-300 rounded-lg bg-white">
                <SignatureCanvas
                  ref={sigRef}
                  penColor="black"
                  canvasProps={{
                    className: "w-full h-40 rounded-lg"
                  }}
                />
              </div>

              <div className="flex gap-3 mt-4">
                <button
                  type="button"
                  onClick={clearSignature}
                  className="px-4 py-2 bg-red-500 text-white rounded-lg hover:opacity-90"
                >
                  Effacer
                </button>

                {/* <button
                  type="button"
                  onClick={saveSignature}
                  className="px-4 py-2 bg-primary text-white rounded-lg hover:opacity-90"
                >
                  Enregistrer la signature
                </button> */}
              </div>

              {/* {signature && (
                <div className="mt-4">
                  <p className="text-sm text-gray-500 mb-2">Signature enregistrée :</p>
                  <img src={signature} alt="signature" className="h-24 border rounded" />
                </div>
              )} */}
            </div>
          </div>

          {/* Boutons de Navigation */}
          <div className="flex justify-center gap-4 mt-8 pt-6 border-t">
            <Link
              to="/step-6"
              className="rounded-full border border-gray-300 px-6 py-3 text-gray-700 flex items-center gap-2 hover:bg-gray-50 transition"
            >
              ← Retour
            </Link>
            {/* <button
              onClick={handleContinue}
              disabled={!declared}
              className={`rounded-full px-8 py-3 text-secondary font-medium flex items-center gap-2 transition ${
                declared
                  ? 'bg-primary hover:bg-primary-dark cursor-pointer'
                  : 'bg-gray-400 cursor-not-allowed opacity-50'
              }`}
            >
              Continuer →
            </button> */}
            <button
              onClick={handleSubmit}
              disabled={isLoading}
              className={`rounded-full border border-gray-300 px-6 py-3 flex items-center gap-2 bg-primary text-secondary hover:bg-primary-dark ${isLoading ? 'opacity-50 cursor-not-allowed' : ''}`}
            >
              {isLoading ? 'Calcul en cours...' : 'Valider →'}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
